import axios from 'axios'
import store from "@/store";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
      // 可以在这里添加token等请求头
      // 添加语言参数到请求头
      config.headers['lang'] = store.state.app.language
      return config
    },
    error => {
      console.error('请求错误:', error)
      return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
      const res = response.data
      return res
    },
    error => {
      console.error('响应错误:', error)
      return Promise.reject(error)
    }
)

// 封装请求方法
const request = {
  get(url, params, config = {}) {
    return service.get(url, {
      params,
      ...config
    })
  },

  post(url, data, config = {}) {
    return service.post(url, data, config)
  },

  put(url, data, config = {}) {
    return service.put(url, data, config)
  },

  delete(url, params, config = {}) {
    return service.delete(url, {
      params,
      ...config
    })
  }
}

export default request